module.exports = __webpack_public_path__ + "img/play.34df3111.svg";